/**
 * DG Cart Merge Modal — v2.0
 * Distribution Gauthier — 2026
 * ─────────────────────────────────────────────────────────────
 * Intercepte les clics sur les liens de connexion quand le
 * panier invité (local) contient des articles.
 *
 * 3 choix :
 *   'merge'       → fusionner avec la commande en cours
 *   'keep_local'  → garder le panier actuel (écrase le serveur)
 *   'keep_server' → reprendre le panier du compte
 *
 * Design : DG dark theme — fond #0B1E33, accent #1F7AFF, Poppins.
 */
(function () {
    'use strict';

    /* ── Guard : s'active seulement pour les utilisateurs non connectés ── */
    var IS_LOGGED_IN = !!(window.DG_CART_SYNC_CONFIG && window.DG_CART_SYNC_CONFIG.isLoggedIn);
    if (IS_LOGGED_IN) return;

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var _overlayEl = null;
    var _pendingHref = null;
    var _guestItems = [];
    var _guestCount = 0;

    /* ─── Lire le panier invité ──────────────────────────────── */
    function getGuestCart() {
        return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .catch(function () { return { items: [], item_count: 0 }; });
    }

    /* ─── Déterminer si le modal doit s'afficher ─────────────── */
    function shouldShowModal() {
        return getGuestCart().then(function (cart) {
            _guestItems = cart.items || [];
            _guestCount = cart.item_count || 0;
            return _guestCount > 0;
        });
    }

    /* ─── Construire et injecter le DOM du modal ─────────────── */
    function buildModal() {
        if (_overlayEl) return;

        var overlay = document.createElement('div');
        overlay.id = 'dg-cart-merge-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'dg-merge-title');

        var guestLabel = _guestCount === 1
            ? '1 article'
            : _guestCount + ' articles';

        overlay.innerHTML = [
            '<div class="dg-merge__panel">',

            /* Handle mobile */
            '<div class="dg-merge__handle"></div>',

            /* Header */
            '<div class="dg-merge__header">',
            '<div class="dg-merge__icon">',
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>',
            '<line x1="3" y1="6" x2="21" y2="6"/>',
            '<path d="M16 10a4 4 0 0 1-8 0"/>',
            '</svg>',
            '</div>',
            '<h2 class="dg-merge__title" id="dg-merge-title">Commande en cours</h2>',
            '<p class="dg-merge__subtitle">',
            'Votre panier contient <strong>' + guestLabel + '</strong>.',
            ' Que souhaitez-vous faire\u00a0?',
            '</p>',
            '</div>',

            /* Options */
            '<div class="dg-merge__options">',

            /* Option 1 : Fusionner (recommandé) */
            '<button class="dg-merge__option dg-merge__option--primary" data-choice="merge" aria-label="Fusionner avec ma commande en cours">',
            '<span class="dg-merge__option-icon">',
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
            '<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
            '</svg>',
            '</span>',
            '<span class="dg-merge__option-text">',
            '<span class="dg-merge__option-label">Fusionner avec ma commande en cours</span>',
            '<span class="dg-merge__option-desc">Combiner vos articles actuels avec ceux de votre compte</span>',
            '</span>',
            '<svg class="dg-merge__option-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>',
            '</button>',

            /* Option 2 : Garder le panier actuel */
            '<button class="dg-merge__option" data-choice="keep_local" aria-label="Garder mon panier actuel">',
            '<span class="dg-merge__option-icon">',
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
            '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
            '</svg>',
            '</span>',
            '<span class="dg-merge__option-text">',
            '<span class="dg-merge__option-label">Garder mon panier actuel</span>',
            '<span class="dg-merge__option-desc">Vos ' + guestLabel + ' actuels remplaceront le panier de votre compte</span>',
            '</span>',
            '<svg class="dg-merge__option-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>',
            '</button>',

            /* Option 3 : Reprendre le panier du compte */
            '<button class="dg-merge__option" data-choice="keep_server" aria-label="Reprendre mon panier de compte">',
            '<span class="dg-merge__option-icon">',
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
            '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
            '</svg>',
            '</span>',
            '<span class="dg-merge__option-text">',
            '<span class="dg-merge__option-label">Reprendre mon panier de compte</span>',
            '<span class="dg-merge__option-desc">Votre panier actuel sera remplacé par celui enregistré dans votre compte</span>',
            '</span>',
            '<svg class="dg-merge__option-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>',
            '</button>',

            '</div>',

            /* Annuler */
            '<button class="dg-merge__cancel" data-choice="cancel">Annuler — rester sur la page</button>',

            '</div>'
        ].join('');

        document.body.appendChild(overlay);
        _overlayEl = overlay;

        /* Afficher le modal avec animation */
        requestAnimationFrame(function () {
            overlay.classList.add('is-visible');
        });

        /* Focus sur le premier choix */
        setTimeout(function () {
            var firstBtn = overlay.querySelector('.dg-merge__option');
            if (firstBtn) firstBtn.focus();
        }, 320);

        /* Événements */
        overlay.addEventListener('click', _onOverlayClick);
        document.addEventListener('keydown', _onKeydown);
    }

    /* ─── Clic sur l'overlay (fermeture par clic extérieur) ───── */
    function _onOverlayClick(e) {
        var btn = e.target.closest('[data-choice]');
        if (btn) {
            handleChoice(btn.dataset.choice);
            return;
        }
        /* Clic hors du panel → annuler */
        if (!e.target.closest('.dg-merge__panel')) {
            handleChoice('cancel');
        }
    }

    /* ─── Touche Escape ──────────────────────────────────────── */
    function _onKeydown(e) {
        if (e.key === 'Escape') handleChoice('cancel');
    }

    /* ─── Fermer le modal ────────────────────────────────────── */
    function closeModal() {
        if (!_overlayEl) return;
        _overlayEl.classList.remove('is-visible');
        document.removeEventListener('keydown', _onKeydown);
        var el = _overlayEl;
        setTimeout(function () {
            if (el && el.parentNode) el.parentNode.removeChild(el);
        }, 300);
        _overlayEl = null;
        _pendingHref = null;
    }

    /* ─── Gérer le choix ─────────────────────────────────────── */
    function handleChoice(choice) {
        if (choice === 'cancel') {
            closeModal();
            return;
        }

        /* Sauvegarder l'action dans sessionStorage */
        try {
            sessionStorage.setItem('dg_cart_merge_action', choice);
        } catch (e) { /* ignore */ }

        /* Pour 'merge' et 'keep_local': sauvegarder les items invités
           AVANT la redirection (ils peuvent changer pendant le login Shopify) */
        if (choice === 'merge' || choice === 'keep_local') {
            var guestPayload = _guestItems.map(function (item) {
                return { id: item.variant_id, quantity: item.quantity };
            });
            try {
                sessionStorage.setItem('dg_cart_merge_guest_items', JSON.stringify(guestPayload));
            } catch (e) { /* ignore */ }
        }

        /* Feedback visuel avant la redirection */
        var chosenBtn = _overlayEl && _overlayEl.querySelector('[data-choice="' + choice + '"]');
        if (chosenBtn) chosenBtn.classList.add('is-loading');

        /* Sauvegarder la page actuelle pour y retourner après connexion */
        try {
            localStorage.setItem('dg_post_login_url', window.location.href);
        } catch (e) { /* ignore */ }

        /* Rediriger vers la page de connexion */
        var href = _pendingHref || '/account/login';
        setTimeout(function () {
            window.location.href = href;
        }, 180);
    }

    /* ─── Intercepter les clics sur les liens de connexion ────── */
    function _interceptLoginLinks() {
        document.addEventListener('click', function (e) {
            var link = e.target.closest('a[href]');
            if (!link) return;

            var href = link.getAttribute('href') || '';
            var isLoginLink =
                href === '/account/login' ||
                href === '/account' ||
                href.startsWith('/account/login') ||
                href.startsWith('https://account.') ||   /* Nouveaux comptes clients Shopify */
                href.includes('customer_identity') ||
                href.includes('/challenge');

            if (!isLoginLink) return;

            e.preventDefault();
            _pendingHref = href;

            shouldShowModal().then(function (show) {
                if (show) {
                    buildModal();
                } else {
                    /* Pas d'articles dans le panier → connexion directe */
                    window.location.href = href;
                }
            });
        });
    }

    /* ─── Init ────────────────────────────────────────────────── */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _interceptLoginLinks);
    } else {
        _interceptLoginLinks();
    }

})();
